const GoogleMap: React.FC = () => {
  return (
    <iframe
      className="w-full h-[500px]"
      frameBorder="0"
      scrolling="no"
      marginHeight={0}
      marginWidth={1000}
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9593.19589366887!2d-1.4070106!3d53.0509353!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x478dc89a59480039!2s3H%20CCTV%20%26%20Alarms!5e0!3m2!1sen!2sau!4v1667005943705!5m2!1sen!2sau"
    />
  )
}

export default GoogleMap
